//  CreateSchedulePriceChange.aspx
var CreateSchedulePriceChange = (function (backOffice, $) {

    backOffice.CreateSchedulePriceChange = (function() {
        var scopeSelector = backOffice.options.scopeSelector;
        var outlets = $("#outlets");
        var roundings = $("#roundingDollar, #roundingDecimal");
        var cvMasterPromotionalPriceEndDate = $("#cvMasterPromotionalPriceEndDate")[0];
        var lbSelection = {};

        var PRICE_TO_CHANGE = {
            masterPosPrice: 1,
            outletPosPrice: 2,
            masterPromotionalPrice: 3,
            outletPromotionalPrice: 4
        };

        var ADJUSTMENT_DETAILS = {
            setPriceTo: 1,
            increasePriceBy: 2,
            decreasePriceBy: 3,
            posPriceRelated: 4,
            markupTarget: 5,
            clearPrice: 6
        };

        var ROUNDING_TYPE = {
            noRounding: 1,
            nearestMultiple: 2 
        }

        var posPriceRelatedOption = $("#ddlAdjustmentReason option[value='" + ADJUSTMENT_DETAILS.posPriceRelated + "']");
        var markupTargetOption = $("#ddlAdjustmentReason option[value='" + ADJUSTMENT_DETAILS.markupTarget + "']");
        var markupTargetHelpText = $("#markupTargetHelpText");
        var baseDetailsHelpText = $("#baseDetailsHelpText");
        var clearPriceHelpText = $("#clearPriceHelpText");
        var clearPriceOption = $("#ddlAdjustmentReason option[value='" + ADJUSTMENT_DETAILS.clearPrice + "']");

        var isOutletsVisible = function () {
            var priceToChange = parseInt($("#ddlPriceToChange option:selected").val());
            return priceToChange === PRICE_TO_CHANGE.outletPosPrice || priceToChange === PRICE_TO_CHANGE.outletPromotionalPrice;
        }

        var isRoundingOptionsVisible = function () {
            var adjType = parseInt($("#ddlAdjustmentReason option:selected").val());
            return !(adjType === ADJUSTMENT_DETAILS.setPriceTo || adjType === ADJUSTMENT_DETAILS.markupTarget || adjType === ADJUSTMENT_DETAILS.clearPrice);
        }

        var isOutletPromotionalPriceDateRangeVisible = function (){
            var priceToChange = parseInt($("#ddlPriceToChange option:selected").val());
            var adjustmentReason = getSelectedAdjustmentReason();

            var isOutletPromoPrice = priceToChange === PRICE_TO_CHANGE.outletPromotionalPrice;
            var isNotClearPrice = adjustmentReason !== ADJUSTMENT_DETAILS.clearPrice;

            return isOutletPromoPrice && isNotClearPrice;
        }

        var isPosPriceRelatedOptionVisible = function(){
            var priceToChange = parseInt($("#ddlPriceToChange option:selected").val());
            return priceToChange === PRICE_TO_CHANGE.masterPromotionalPrice || priceToChange === PRICE_TO_CHANGE.outletPromotionalPrice;
        }

        var isMarkupTargetOptionVisible = function(){
            var priceToChange = parseInt($("#ddlPriceToChange option:selected").val());
            return priceToChange === PRICE_TO_CHANGE.masterPosPrice || priceToChange === PRICE_TO_CHANGE.outletPosPrice;
        }

        var isClearPriceOptionVisible = function () {
            var priceToChange = parseInt($("#ddlPriceToChange option:selected").val());
            return priceToChange === PRICE_TO_CHANGE.outletPosPrice || priceToChange === PRICE_TO_CHANGE.outletPromotionalPrice;
        }

        var getSelectedAdjustmentReason = function (){
            return parseInt($("#ddlAdjustmentReason option:selected").val());
        }

        var registerEvents = function () {
            $("#ddlPriceToChange").change(function () {
                outletVisibility();
                promotionalPriceEndDateVisibility();
                outletPromotionalPriceDateRangeVisibility();
                posPriceRelatedSelectionVisibility();
                markupTargetSelectionVisibility();
                markupTargetSelectionTextToggle();
                clearPriceSelectionVisibility();
                handleAdjustmentReason();
            });

            $("#ddlRoundingTypeDollar, #ddlRoundingTypeDecimal").change(function () {
                manageRoundingValidation($(this));
            });

            $("#dollarLabel").click(function () {
                $('#txtSelectedValueType').val('1');
            });

            $("#percentLabel").click(function () {
                $('#txtSelectedValueType').val('2');
            });

            $("#ddlAdjustmentReason").change(function () {
                var selectedReason = getSelectedAdjustmentReason();

                if (selectedReason === ADJUSTMENT_DETAILS.clearPrice) {
                    $('#surcharge-container').hide();
                    $('#adjustment-container').removeClass('col-xs-8');
                    $('#adjustment-container').addClass('col-xs-12');
                }
                else {
                    $('#adjustment-container').removeClass('col-xs-12');
                    $('#adjustment-container').addClass('col-xs-8');
                    $('#surcharge-container').show();

                    if (selectedReason === ADJUSTMENT_DETAILS.setPriceTo
                        || selectedReason === ADJUSTMENT_DETAILS.markupTarget) {
                        $('#adjustmentDetailsInput').removeClass('col-xs-8');
                        $('#adjustmentDetailsInput').addClass('col-xs-10');
                        if (selectedReason === ADJUSTMENT_DETAILS.setPriceTo) {
                            $("div.surcharge-symbol.pull-left.col-xs-2").show();
                            $("#dollarLabel").click();
                            $("#percentLabel").hide();
                        }
                        else {
                            $("#percentLabel").show();
                            $("#percentLabel").click();
                            $("div.surcharge-symbol.pull-left.col-xs-2").hide();
                        }
                    }
                    else {
                        $("div.surcharge-symbol.pull-left.col-xs-2").show();
                        $("#percentLabel").show();
                        $('#adjustmentDetailsInput').removeClass('col-xs-10');
                        $('#adjustmentDetailsInput').addClass('col-xs-8');
                    }
                }
                
                roundingOptionsVisibility();
                manageRoundingValidation($("#ddlRoundingTypeDollar"));
                manageRoundingValidation($("#ddlRoundingTypeDecimal"));
                baseDetailsHelpTextVisibility();
                markupTargetHelpTextVisibility();
                clearPriceHelpTextVisibility();
                outletPromotionalPriceDateRangeVisibility();
            });
        },
            initialize = function (options) {
                $.extend(backOffice.options, options);
                lbSelection = options.lbSelection;
                registerEvents();
                initializeAdjustmentDetails();
                initializeValidation();
                toggleNextButtonForValidation();
            },
            proceedSave = function () {
                toggleValidators();
                if (Page_ClientValidate('vg')) {
                    backOffice.ToggleLoader(true);
                    return true;
                }

                return false;
            },
            goNext = function () {
                toggleValidators();
                if (Page_ClientValidate('vg')) {
                    return true;
                }

                return false;
            },
            goBack = function () {
                var schedulSettingsSection = $("#jobSettings", scopeSelector);
                var parameterSettingsSection = $("#searchTab", scopeSelector);

                schedulSettingsSection.removeClass("hidden");
                parameterSettingsSection.addClass("hidden");
            },

            outletVisibility = function () {
                isOutletsVisible()
                    ? outlets.show()
                    : outlets.hide();
            },

            roundingOptionsVisibility = function () {
                isRoundingOptionsVisible()
                    ? roundings.show()
                    : roundings.hide();
            },

            outletPromotionalPriceDateRangeVisibility = function () {
                isOutletPromotionalPriceDateRangeVisible()
                    ? $("#trPromotionalPriceDateRange").show()
                    : $("#trPromotionalPriceDateRange").hide();
            },

            resetAdjustmentDetails = function (){
                $("div.surcharge-symbol.pull-left.col-xs-2").show();
                $("#ddlAdjustmentReason").val(ADJUSTMENT_DETAILS.setPriceTo);
                $("#dollarLabel").click();
                $("#percentLabel").hide();
                roundings.hide();
            },

            initializeAdjustmentDetails = function (){
                posPriceRelatedSelectionVisibility();
                markupTargetSelectionVisibility();
                markupTargetSelectionTextToggle();
                clearPriceSelectionVisibility();
                baseDetailsHelpTextVisibility();
                markupTargetHelpTextVisibility();
                clearPriceHelpTextVisibility();
            },

            initializeValidation = function() {
                outletVisibility();
                roundingOptionsVisibility();
                promotionalPriceEndDateVisibility();
                outletPromotionalPriceDateRangeVisibility();

                manageRoundingValidation($("#ddlRoundingTypeDollar"));
                manageRoundingValidation($("#ddlRoundingTypeDecimal"));
                $("#ddlAdjustmentReason").change();
            },

            manageRoundingValidation = function (element) {
                if (element === undefined) {
                    return;
                }

                var isAdjTypeSetPriceTo = getSelectedAdjustmentReason() === ADJUSTMENT_DETAILS.setPriceTo;
                var isNoRounding = parseInt((element.val())) === ROUNDING_TYPE.noRounding;
                var inputForValidation = $("#" + $(element.parent()).attr("data-input-id"));
                var reqValidator = $("#" + $(element.parent()).attr("data-rfv-id"));;
                isNoRounding && inputForValidation.val("");
                inputForValidation.prop('disabled', isNoRounding);
                var isValidationRequired = !isNoRounding && !isAdjTypeSetPriceTo;
                ValidatorEnable(reqValidator[0], isValidationRequired);
            },

            validateOutletsList = function (sender, args) {
                if (isOutletsVisible()) {
                    args.IsValid = $find(lbSelection).get_items().get_count() > 0 ? true : false;
                } else {
                    args.IsValid = true;
                }
            },

            validateOutletPromotionalPriceStartDate = function (sender, args){
                if (isOutletPromotionalPriceDateRangeVisible()) {
                    if (!args.Value || args.Value === ""){
                        args.IsValid = false;
                        return;
                    }
                }

                args.IsValid = true;
            },

            validateOutletPromotionalPriceEndDate = function (sender, args){
                if (isOutletPromotionalPriceDateRangeVisible()) {
                    if (!args.Value || args.Value === "") {
                        args.IsValid = false;
                        sender.innerText = "Required field";
                        return;
                    }
                    else{
                        var startDateStr = $("input[id$='dtOutletPromotionalPriceStartDate']").val();
                        var scheduleDateStr = $("input[id$='dtExecutionTime']").val();

                        var startDate = parseRadDateTime(startDateStr);
                        var endDate = parseRadDateTime(args.Value);
                        var scheduleDate = parseRadDateTime(scheduleDateStr);

                        if (startDate > endDate){
                            args.IsValid = false;
                            sender.innerText = "End Date must be greater than or equal to Start Date";
                            return;
                        }

                        if (endDate <= scheduleDate){
                            args.IsValid = false;
                            sender.innerText = "End Date must be greater than Scheduled Price Change Date";
                            return;
                        }
                    }
                }

                args.IsValid = true;
            },

            promotionalPriceEndDateVisibility = function () {
                isMasterPromotionalPrice() ? $("#masterPromotionalPriceEndDate").show() : $("#masterPromotionalPriceEndDate").hide();
            },
            
            posPriceRelatedSelectionVisibility = function (){
                if (isPosPriceRelatedOptionVisible()){
                    posPriceRelatedOption.show();
                }
                else{
                    posPriceRelatedOption.hide();
                }
            },

            markupTargetSelectionVisibility = function (){
                if (isMarkupTargetOptionVisible()){
                    markupTargetOption.show();
                }
                else{
                    markupTargetOption.hide();
                }
            },

            markupTargetSelectionTextToggle = function (){
                var priceToChange = parseInt($("#ddlPriceToChange").val());
                if (priceToChange === PRICE_TO_CHANGE.masterPosPrice){
                    markupTargetOption.text("Set Markup Target % To");
                }
                else if (priceToChange === PRICE_TO_CHANGE.outletPosPrice){
                    markupTargetOption.text("Adjust by Markup Target %");
                }
            },
            markupTargetHelpTextVisibility = function(){
                var adjustmentReason = getSelectedAdjustmentReason();
                if (adjustmentReason === ADJUSTMENT_DETAILS.markupTarget){
                    markupTargetHelpText.show();
                }
                else{
                    markupTargetHelpText.hide();
                }
            },

            baseDetailsHelpTextVisibility = function () {
                var adjustmentReason = getSelectedAdjustmentReason();
                if (adjustmentReason === ADJUSTMENT_DETAILS.clearPrice) {
                    baseDetailsHelpText.hide();
                }
                else {
                    baseDetailsHelpText.show();
                }
            },

            clearPriceSelectionVisibility = function () {
                if (isClearPriceOptionVisible()) {
                    clearPriceOption.show();
                }
                else {
                    clearPriceOption.hide();
                }
            },
            clearPriceHelpTextVisibility = function () {
                var adjustmentReason = getSelectedAdjustmentReason();
                if (adjustmentReason === ADJUSTMENT_DETAILS.clearPrice) {
                    clearPriceHelpText.show();
                }
                else {
                    clearPriceHelpText.hide();
                }
            },

            handleAdjustmentReason = function () {
                var selectedReason = getSelectedAdjustmentReason();
                var hiddenReasonOptions = [];
                $("#ddlAdjustmentReason option").each(function (i, el) {
                    if ($(el).css('display') == 'none') {
                        hiddenReasonOptions.push(parseInt($(el).val()));
                    }
                });
                if (hiddenReasonOptions.includes(selectedReason)) {
                    $("#ddlAdjustmentReason").val(ADJUSTMENT_DETAILS.setPriceTo);
                    $("#ddlAdjustmentReason").change();
                }
            };

        var toggleValidators = function () {
            var isMasterPromotionalPriceChecked = isMasterPromotionalPrice();
            ValidatorEnable(rfvMasterPromotionalPriceEndDate, isMasterPromotionalPriceChecked);
            ValidatorEnable(cvMasterPromotionalPriceEndDate, isMasterPromotionalPriceChecked);

            var selectedReason = getSelectedAdjustmentReason();
            if (selectedReason === ADJUSTMENT_DETAILS.clearPrice) {
                ValidatorEnable($('#rfvAmountOfPriceChange')[0], false);
                ValidatorEnable($('#revAmountOfPriceChange')[0], false);
            }
            else {
                ValidatorEnable($('#rfvAmountOfPriceChange')[0], true);
                ValidatorEnable($('#revAmountOfPriceChange')[0], true);
            }
        }

        var isMasterPromotionalPrice = function () {
            var priceToChange = parseInt($("#ddlPriceToChange").val());
            return priceToChange === PRICE_TO_CHANGE.masterPromotionalPrice;
        }

        var validateDatePromotionalPriceEndDate = function (sender, args) {
            if (args.Value && (args.Value !== "")) {
                args.IsValid = new Date($("input[id$='dtMasterPromotionalPriceEndDate']").val()).setHours(0, 0, 0, 0) >=
                    parseRadDateTime($("input[id$='dtExecutionTime']").val()).setHours(0, 0, 0, 0);
                return;
            }

            args.IsValid = true;
        }

        var onExecutionTimeChange = function (){
            toggleNextButtonForValidation();
            ValidatorEnable(cvMasterPromotionalPriceEndDate, true && isMasterPromotionalPrice());
        };

        var getMinimumExecutionDate = function (){
            var tomorrow = new Date();

            return BackOffice.GetGodMode() ? new Date(new Date(tomorrow.setDate(tomorrow.getDate())).setHours(0, 0, 0, 0)) : new Date(new Date(tomorrow.setDate(tomorrow.getDate() + 1)).setHours(0, 0, 0, 0));
        };

        var toggleNextButtonForValidation = function(){
            var $nextButton = $("button[id$='btnNext']");
            if ($("#cvExecutionTime").is(":visible")){
                $nextButton.attr("disabled", "disabled");
            }
            else{
                $nextButton.removeAttr("disabled");
            }
        }
  
        return $.extend(backOffice.CreateSchedulePriceChange, {
            Init: initialize,
            ProceedSave: proceedSave,
            GoNext: goNext,
            GoBack: goBack,
            ValidateOutletsList: validateOutletsList,
            ValidateDatePromotionalPriceEndDate: validateDatePromotionalPriceEndDate,
            ValidateOutletPromotionalPriceStartDate: validateOutletPromotionalPriceStartDate,
            ValidateOutletPromotionalPriceEndDate: validateOutletPromotionalPriceEndDate,
            OnExecutionTimeChange: onExecutionTimeChange
        });
    })();

    return backOffice.CreateSchedulePriceChange;
})(BackOffice || {}, jQuery);
